<script lang="ts" setup>
import PageLink from '@/pages/hence/components/PageLink.vue'
import Banner from './components/Banner.vue'
import List from './components/List.vue'
import Newsletter from '@/pages/hence/components/Newsletter.vue'
import { useArticleStore } from '@/stores'
import type { ResponseConfig, IArticleTopic, IArticleTopicFilter, IHomeHenceCard } from '@/utils/types'
import useSeo from './seo'

const route = useRoute()
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
const res = ref<ResponseConfig>({
  code: 0,
  data: {
    top: [] as Array<IArticleTopic>,
    list: {
      data: [] as Array<IArticleTopic>,
      meta: null
    }
  },
  message: ''
})
const filter = ref<IArticleTopicFilter>({
  page: 1,
  per_page: 9,
  category_id: []
})

const banners = computed(() => {
  const tops = res.value.data?.top || []
  return tops.map((item: IArticleTopic) => {
    return {
      image: item.image,
      category: item.publish_date,
      title: item.subject,
      text: item.description
    }
  })
})
const articles = computed(() => {
  const lists = res.value.data?.list?.data || []
  return lists.map((item: IArticleTopic) => {
    return {
      image: item.image,
      category: item.publish_date,
      title: item.subject,
      link: item.url
    } as IHomeHenceCard
  })
})

const pageMeta = computed(() => {
  const list = res.value.data?.list
  return list?.meta ?? null
})

const handleChangePage = async (page: number) => {
  const f = {
    ...filter.value,
    page,
  }
  res.value = await articleStore.fetchArticleTopics(f)
  navigateTo({ path: route.path, query: { page } })
}

handleChangePage(parseInt(route.query.page as string) || 1)

useSeo()
</script>

<template>
  <section class="hence">
    <div class="hence__top">
      <div class="hence__top__logo">
        <Nimg src="./images/hence_logo.svg" format="" />
      </div>
      <h1 class="hence__top__title">專題報導</h1>
      <PageLink />
    </div>
    <Banner :banners="banners" />
    <List :items="articles" :handleChangePage="handleChangePage" :meta="pageMeta" />
    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__logo {
      width: 100%;
      max-width: toRem(276);

      img {
        display: block;
        width: 100%;
      }
    }

    &__title {
      margin-bottom: toRem(40);
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.3;
    }
  }

  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}
</style>
